(function () {
    'use strict';

    var imgEditorCanvasBaseService = function ($http, $timeout, $q) {

        var self = this;

        /*
         * 功能：验证是否为数字
         * 参数：
         * value： 需要验证的值
         */
        self.isNumber = function (value) {
            return !isNaN(Number(value));
        };

        /*
         *功能：dataURL转blob
         *说明：dataURL 的格式为 “data:image/png;base64,****”,逗号之前都是一些说明性的文字
         * 传入参数：
         *   data： dataURL格式数据
         * 返回参数：
         *   blob： blob对象, blob.size获取图片文件的大小
         */
        self.dataURLtoBlob = function (data) {

            var blob, uIntA;

            if (!data) {return;}
            data = data.split(',')[1];
            // window.btoa()编码，window.atob解码
            data = window.atob(data);
            // 获取8位无符号整数值的类型化数组
            uIntA = new Uint8Array(data.length);
            for (var i = 0; i < data.length; i++) {
                // 返回在指定的位置的字符的 Unicode 编码
                uIntA[i] = data.charCodeAt(i);
            }
            
            blob = new Blob([uIntA], {
                type: 'image/jpeg'
            });
            return blob;

        };

        /*
         功能： 给元素添加事件监听器
         参数：
             oTarget： 添加事件的html元素
             sEventType： 事件类型，没有on
             fnHandler： 事件处理函数
         */
        self.addEventHandler = function (oTarget, sEventType, fnHandler) {

            if (oTarget.addEventListener) {
                oTarget.addEventListener(sEventType, fnHandler, false);
            } else if (oTarget.attachEvent) {
                oTarget.attachEvent('on' + sEventType, fnHandler);
            } else {
                oTarget['on' + sEventType] = fnHandler;
            }

        };

        /*
         功能： 删除元素事件监听器
         参数：
             oTarget： 删除事件监听器的html元素
             sEventType： 事件类型，没有on
             fnHandler： 事件处理函数
         */
        self.removeEventHandler = function (oTarget, sEventType, fnHandler) {

            if (oTarget.removeEventListener) {
                oTarget.removeEventListener(sEventType, fnHandler, false);
            } else if (oTarget.detachEvent) {
                oTarget.detachEvent('on' + sEventType, fnHandler);
            } else {
                oTarget['on' + sEventType] = null;
            }

        };

        /*
         功能：改变fun的上下文为object,fun之后的参数做为fun的参数调用，改变fun的上下文
         */
        self.Bind = function (object, fun) {

            var args = Array.prototype.slice.call(arguments).slice(2);
            return function () {
                return fun.apply(object, args);
            };

        };

        /*
         功能：给给object元素绑定事件监听器fun,fun之后的参数做为fun的参数调用,改变fun的上下文
         */
        self.BindAsEventListener = function (object, fun) {

            var args = Array.prototype.slice.call(arguments).slice(2);
            return function (event) {
                return fun.apply(object, [event || window.event].concat(args));
            };

        };

        /*
         功能: 获取元素节点在视口中的位置，参考点为页面的左上角
         参数:
             node html元素节点
         */
        self.getNodePosition = function (node) {

            var nodeTemp = node, l = 0, t = 0;

            while (nodeTemp != document.body && nodeTemp != null) {
                l += nodeTemp.offsetLeft;
                t += nodeTemp.offsetTop;
                nodeTemp = nodeTemp.offsetParent;
            }
            return {
                left: l,
                top: t
            };
        };

    };

    angular.module('imgEditorCanvasModule').factory('imgEditorCanvasBaseService', [
        '$http', '$timeout', '$q',
        function ($http, $timeout, $q) {
            return new imgEditorCanvasBaseService($http, $timeout, $q);
        }
    ]);
}());
